export const getPointsOfSale = (state) =>
  state.pointsOfSale.byID && Object.values(state.pointsOfSale.byID);

export const getPointOfSaleByID = (id) => (state) =>
  state.pointsOfSale.byID[id] || {};
